#import "../../../../common/graphql/EntityDocumentsFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query InvoiceModalDetails($id: UUID!) {
  invoice(id: $id) {
    id
    _documentPackageId
    approvalTriggerDate
    _elapsedTriggerDays
    statusHintOverrideId
    statusHintOverride
    _isEnvironmentalsExist
    transactionTypeId
    _rowTimestamp
    _isApprovalHistoryExists
    description
    isDraft
    _linkedInvoiceId
    _isUpdatable
    _isApprovalRevocable
    _isUserRevoker
    _isProtected
    _receiptsTotal
    invoiceDate
    invoiceNumber
    controlTotalAmount
    reimburseAmount
    reimburseAccountReference
    entityAppliedAmounts {
      appliedTotal
    }
    company {
      id
      name
    }
    vendorReference
    vendorId
    currency {
      id
      isoCode
      name
    }
    department {
      name
    }
    corporatePeriodId
    companyCorporatePeriod {
      id
      _periodYear
      startDate
      endDate
    }
    businessUnit {
      name
    }
    transactionType {
      transactionType
      layoutType
      isDocumentSigningPayment
    }
    statusType {
      statusType
      approvalState
    }
    _isAccountingEntry
    _isHistory
    _accountingStampDate
    _accountingStampUserId
    _accountingStampUserName
    _accountingStampTransactionReference
    _isTransactionCancelled
    _isAccountingEntryStampedComplete
    companyTransactionType {
      exportLayout
    }
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    currencyId
    departmentId
    businessUnitId
    _isDeletable
    _isDocumentsExist
    bankAccountNumber
    bankIbanCode
    bankName
    bankRoutingNumber
    bankSortCode
    bankSwiftCode
    bankAccountName
    cardHolderId
    invoiceDistributions(orderBy: [ACCOUNT_REFERENCE_ASC]) {
      aggregates {
        sum {
          distributionAmount
        }
      }
      nodes {
        id
        _createdDate
        _isDeletable
        _isUpdatable
        _rowTimestamp
        accountReference
        additionalDescription
        businessUnitId
        businessUnit {
          id
          name
        }
        departmentId
        department {
          id
          name
        }
        distributionAmount
        productionIncentiveId
        productionIncentive {
          incentiveType {
            incentiveType
          }
        }
        projectReference
        documentFileDistributionId
        poEntityDocumentId
        isPoCharge
        purchaseOrderReference
        statusTypeId
        statusType {
          statusType
        }
        setReference
        tax1099T4TypeId
        tax1099t4Type {
          tax1099T4Type
        }
        referenceCode1
        referenceCode2
        referenceCode3
        referenceCode4
        referenceCode5
        _ff1Name
        _ff2Name
        _ff3Name
        _ff4Name
        statusExplanation
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _rowTimestamp
        _createdDate
        createdByUser
      }
    }
    userMessagesByEntityId {
      totalCount
    }
    invoiceHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
        documentPosition
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
    entityEnvironmentalsByEntityId {
      nodes {
        description
        endDate
        startDate
        _rowTimestamp
        _createdDate
        id
        _isDeletable
        _isUpdatable
        environmentalMetric {
          environmentalMetric
          layoutType
        }
        environmentalMetricId
        entityEnvironmentalItems(
          orderBy: ENVIRONMENTAL_IMPACT_TYPE_BY_ENVIRONMENTAL_IMPACT_TYPE_ID__ENVIRONMENTAL_IMPACT_ASC
        ) {
          nodes {
            carbonCreditsAmount
            entityEnvironmentalId
            environmentalImpactTypeId
            _isIntegerFormat
            _isFloatFormat
            _isAmountFormat
            feet
            gallons
            hours
            id
            kilogram
            kilometers
            kilowattHours
            litres
            meters
            metricTonnes
            miles
            omissionsEquivalent
            pounds
            quantity
            therms
            tons
            yards
            _rowTimestamp
            _isUpdatable
            _isDeletable
            environmentalImpactType {
              environmentalImpact
            }
          }
        }
      }
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
